import { render, staticRenderFns } from "./AreaWiseAQIComponent.vue?vue&type=template&id=865bdad6"
import script from "./AreaWiseAQIComponent.vue?vue&type=script&lang=js"
export * from "./AreaWiseAQIComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports